const IconMute = () => {
  return (
    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6823 1.81232C16.2812 2.08315 16.6667 2.6769 16.6667 3.33315V23.3332C16.6667 23.9894 16.2812 24.5832 15.6823 24.854C15.0833 25.1248 14.3802 25.0154 13.8906 24.5779L6.86458 18.3332H3.33333C1.49479 18.3332 0 16.8384 0 14.9998V11.6665C0 9.82794 1.49479 8.33315 3.33333 8.33315H6.86458L13.8906 2.08836C14.3802 1.65086 15.0833 1.54669 15.6823 1.81232V1.81232ZM22.1354 8.69773L25 11.5623L27.8646 8.69773C28.3542 8.20815 29.1458 8.20815 29.6302 8.69773C30.1146 9.18732 30.1198 9.97898 29.6302 10.4634L26.7656 13.3279L29.6302 16.1925C30.1198 16.6821 30.1198 17.4738 29.6302 17.9581C29.1406 18.4425 28.349 18.4477 27.8646 17.9581L25 15.0936L22.1354 17.9581C21.6458 18.4477 20.8542 18.4477 20.3698 17.9581C19.8854 17.4686 19.8802 16.6769 20.3698 16.1925L23.2344 13.3279L20.3698 10.4634C19.8802 9.97378 19.8802 9.18211 20.3698 8.69773C20.8594 8.21336 21.651 8.20815 22.1354 8.69773V8.69773Z"
        fill="black"
      />
    </svg>
  );
};

export default IconMute;
